export const TASK_STATUS = [
  { label: 'Đến hạn', value: -5, key: 'DUE_SOON', className: '' },
  { label: 'Quá hạn', value: -4, key: 'EXPIRED', className: '' },
  { label: 'Đã xác nhận', value: -3, key: 'APPROVED', className: 'status-success' },
  { label: 'Từ chối', value: -2, key: 'REJECTED', className: 'status-error' },
  { label: 'Chờ xác nhận', value: -1, key: 'WAITING_FOR_APPROVAL', className: 'status-pending' },
  { label: 'Bản nháp', value: 0, key: 'DRAFT', className: 'status-pending' },
  { label: 'Tạo mới', value: 1, key: 'TODO', className: 'status-pending' },
  { label: 'Đang thực hiện', value: 2, key: 'IN_PROGRESS', className: 'status-info' },
  { label: 'Hoàn thành', value: 3, key: 'DONE', className: 'status-success' },
  { label: 'Hủy', value: 4, key: 'CANCEL', className: 'status-error' },
  { label: 'Tạm dừng', value: 5, key: 'SUSPENDED', className: 'status-warning' },
];

export const TASK_STATUS_MAP = {
  DUE_SOON: -5,
  EXPIRED: -4,
  APPROVED: -3,
  REJECTED: -2,
  WAITING_FOR_APPROVAL: -1,
  DRAFT: 0,
  TODO: 1,
  IN_PROGRESS: 2,
  DONE: 3,
  CANCEL: 4,
  SUSPENDED: 5,
};

export const BASE_TASK_STATUS = [
  { label: 'Tạo mới', value: 1, key: 'TODO' },
  { label: 'Đang thực hiện', value: 2, key: 'IN_PROGRESS' },
  { label: 'Hoàn thành', value: 3, key: 'DONE' },
  { label: 'Tạm dừng', value: 5, key: 'SUSPENDED' },
  { label: 'Hủy', value: 4, key: 'CANCEL' },
];

export const TASK_STATUS_KANBAN = [
  { label: 'Tạo mới', value: 1, key: 'TODO' },
  { label: 'Đang thực hiện', value: 2, key: 'IN_PROGRESS' },
  { label: 'Hoàn thành', value: 3, key: 'DONE' },
  { label: 'Tạm dừng', value: 5, key: 'SUSPENDED' },
  { label: 'Hủy', value: 4, key: 'CANCEL' },
];

export const STATUS_NEED_CONFIRM = [
  { label: 'Hoàn thành', value: 3, key: 'DONE' },
  { label: 'Tạm dừng', value: 5, key: 'SUSPENDED' },
  { label: 'Hủy', value: 4, key: 'CANCEL' },
];

export const TASK_PRIORITY = [
  { label: 'Cao', value: 2, key: 'HIGH', className: 'status-error' },
  { label: 'Trung bình', value: 1, key: 'MEDIUM', className: 'status-warning' },
  { label: 'Thấp', value: 0, key: 'LOW', className: 'status-pending' },
];

export const STATUS_ALLOW_DELETE = [TASK_STATUS_MAP.CANCEL, TASK_STATUS_MAP.TODO];
